import { render } from "./DemographicsSectionDetailsDonorEMROATS.vue?vue&type=template&id=33b13cd0&scoped=true"
import script from "./DemographicsSectionDetailsDonorEMROATS.vue?vue&type=script&lang=js"
export * from "./DemographicsSectionDetailsDonorEMROATS.vue?vue&type=script&lang=js"

import "./DemographicsSectionDetailsDonorEMROATS.vue?vue&type=style&index=0&id=33b13cd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b13cd0"],['__file',"src/components/DemographicsSectionDetailsDonorEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33b13cd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33b13cd0', __exports__)) {
    api.reload('33b13cd0', __exports__)
  }
  
  module.hot.accept("./DemographicsSectionDetailsDonorEMROATS.vue?vue&type=template&id=33b13cd0&scoped=true", () => {
    api.rerender('33b13cd0', render)
  })

}


export default __exports__